import environment from "../environment";

export const Routes = {
    User: {
        addApi: 'user/add',
        editApi: 'user/profile',
        detailApi: 'user/profile',
        listApi: `user/listing`,
        statusApi: 'user/status/change',
        deleteApi: 'user/delete',
        url: 'user',
        permissionKey: 'Users',
        cardSend: 'user/card/send'
    },
    Staff: {
        addApi: 'user/add',
        editApi: 'user/profile',
        detailApi: 'user/profile',
        listApi: `user/listing`,
        url: 'staff',
        statusApi: 'user/status/change',
        deleteApi: 'user/delete',
        permissionKey: 'Staff'
    },

    Venue: {
        addApi: 'venue/add',
        editApi: 'venue/update',
        detailApi: 'venue/detail',
        listApi: `venue/listing`,
        url: 'venue',
        statusApi: 'venue/update',
        deleteApi: 'venue/delete',
        approvalApi: 'venue/approval',
        permissionKey: 'Venue'
    },
    Offer: {
        addApi: 'offer/add',
        editApi: 'offer/update',
        detailApi: 'offer/detail',
        listApi: `offer/listing`,
        url: 'offer',
        statusApi: 'offer/update',
        deleteApi: 'offer/delete',
        permissionKey: 'Offers'
    },
    Transactions: {
        listApi: 'transaction/listing',
        detailApi: 'transaction/detail',
        permissionKey: 'Transactions',
        activeUsers: 'transaction/active/users'

    },
    settings: {
        detailApi: 'settings/detail',
        addApi: 'settings/add',
        permissionKey: 'Settings'
    },
    Content: {
        listApi: 'content/listing',
        detailApi: 'content/detail',
        addApi: 'content/add',
        editApi: 'content/update',
        deleteApi: 'content/delete',
        url: 'content-management',
        permissionKey: 'Content'
    },
    Notification: {
        listApi: 'push-notification/listing',
        detailApi: 'push-notification/detail',
        addApi: 'push-notification/add',
        editApi: 'push-notification/update',
        deleteApi: 'push-notification/delete',
        url: 'notification',
        permissionKey: 'Notification'
    },
    Analytics: {
        url: 'analytics',
        permissionKey: 'Analytics'
    }
}